import Image from './Image';
import Sentence from './Sentence';
import Text from './Text';

export default { Image, Sentence, Text };
